module.exports = __webpack_public_path__ + "img/es-banner-cube-2-tablet.01dceed8.png";